//@ts-check

/**
 * Renders the "Different licensee address" checkbox that sits on the billing
 * section in shipping mode. Unchecked = shipping+billing merged, checked = two
 * separate sections.
 */
export class BillingLicenseeToggleComponent {
  constructor({ checked, isPurchasingForClient, onChange }) {
    this.initallyChecked = checked;
    this.isPurchasingForClient = isPurchasingForClient;
    this.onChange = onChange;
  }

  // Appends the checkbox wrapper to the given parent element (shipping section).
  appendTo(parentElement) {
    this.element = document.createElement("div");
    this.element.dataset.mergeToggle = "billing-licensee";
    this.element.innerHTML = `
      <input type="checkbox" id="ui_different_licensee_address">
      <label for="ui_different_licensee_address" data-id="different_licensee_address_toggle"></label>
    `;
    parentElement.appendChild(this.element);

    this.checkbox = /** @type {HTMLInputElement} */ (
      this.element.querySelector("input")
    );
    this.labelElement = /** @type {HTMLLabelElement} */ (
      this.element.querySelector("label")
    );
    this.renderLabel();

    this.checked = this.initallyChecked;

    this.addListeners();
  }

  // Updates only the label text, preserving the checkbox node and its listener.
  renderLabel() {
    this.labelElement.textContent = `Different License holder${
      this.isPurchasingForClient ? " (client)" : ""
    }`;
  }

  setIsClient(value) {
    this.isPurchasingForClient = value;
    if (this.labelElement) this.renderLabel();
  }

  set checked(value) {
    this.checkbox.checked = value;
  }

  setChecked(value) {
    this.checkbox.checked = value;
  }

  get checked() {
    return this.checkbox.checked;
  }

  addListeners() {
    this._handleChange = () => {
      this.onChange(this.checked);
    };
    this.checkbox.addEventListener("change", this._handleChange);
  }

  removeListeners() {
    this.checkbox.removeEventListener("change", this._handleChange);
  }
}
